module.exports = __webpack_public_path__ + "media/jungle_sound.fda70f31.ogg";